module.exports = __webpack_public_path__ + "img/527.4ba6a4c9.jpg";